import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyBnXgpj9FIb8emGKaMnSyDN3XEEwF3m948",
  authDomain: "ttab-797cf.firebaseapp.com",
  projectId: "ttab-797cf",
  storageBucket: "ttab-797cf.appspot.com",
  messagingSenderId: "367399343716",
  appId: "1:367399343716:web:1e5898d246c6be66299933"
};

const firebaseApp = initializeApp(firebaseConfig);

// Initialize App Check (Bot Protection)
if (typeof window !== "undefined") {
  // Only run in production, not on localhost to avoid blocking local testing
  if (window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1" && !window.location.hostname.includes("192.168.")) {
    initializeAppCheck(firebaseApp, {
      provider: new ReCaptchaV3Provider("6LfacxktAAAAALODlVEfO9fqe1ar8_4oq8BFGvGW"),
      isTokenAutoRefreshEnabled: true
    });
  }
}

export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export const functions = getFunctions(firebaseApp);

// if (window.location.hostname === "localhost" || window.location.hostname.includes("192.168.")) {
//   connectFunctionsEmulator(functions, window.location.hostname, 5001);
// }

export default firebaseApp;